<template>
  <UiHeading
    :force-tag="$config.public.seoHeadingStrategy === 'manual' ? 'h2' : undefined"
    class="richtext__h2"
  >
    <slot />
  </UiHeading>
</template>
